import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";
import { useDispatch, useSelector } from "react-redux";
import { usuariosActions } from "../../store";
import EditItemView from "../../components/common/EditItemView";
import LinkSelect from "../../components/common/LinkSelect";

import _ from "lodash";

const ItemList = ({ variable, text, description }) => {
    return (
        <div className="widget-todolist-item">
            <div className="widget-todolist-input">
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="widget_todolist_1" />
                </div>
            </div>
            <div className="widget-todolist-content">
                <h6 className="mb-2px">{text}</h6>
                <div className="text-gray-500 fw-bold fs-11px">{description}</div>
            </div>
        </div>
    );
};

const DatosUsuario = () => {
    const { id } = useParams();

    const myuser = useSelector((state) => state.session.user) || null;
    const usuario = useSelector((state) => state.usuarios.items[id]) || {};

    const [item, setItem] = useState({ ...usuario });

    const dispatch = useDispatch();

    const handleInputChange = (e) => setItem({ ...item, [e.target.name]: e.target.value });
    const handleCheckboxChange = (e) => setItem({ ...item, [e.target.name]: !item[e.target.name] });

    const validate = () => item && item.name && item.email && (item.id || item.password);

    const onItemSaved = (result) => {
        dispatch(usuariosActions.update([result]));
    };

    return (
        <div>
            <ol className="breadcrumb float-xl-end">
                <li className="breadcrumb-item">
                    <Link to="/usuario">Usuarios</Link>
                </li>
                <li className="breadcrumb-item active">Dato de Usuario</li>
            </ol>
            <h1 className="page-header">Datos de Usuario</h1>

            <div className="row mb-3">
                <div className="col-lg-4">
                    <Panel>
                        <PanelHeader>Usuario: {usuario?.name || " Nuevo registro"}</PanelHeader>
                        <EditItemView
                            endpoint="user"
                            item={item}
                            setItem={setItem}
                            defaultItem={{}}
                            validate={validate}
                            onItemSaved={onItemSaved}>
                            <PanelBody>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="col-md-12 mb-3">
                                            <form onSubmit={(e) => e.preventDefault()} className="form-floating mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control fs-15px"
                                                    placeholder="132123-1"
                                                    onChange={handleInputChange}
                                                    name="name"
                                                    value={item.name || ""}
                                                />
                                                <label className="d-flex align-items-center fs-13px">NOMBRE DE USUARIO</label>
                                            </form>

                                            <form onSubmit={(e) => e.preventDefault()} className="form-floating mb-3 ">
                                                <input
                                                    type="text"
                                                    className="form-control fs-15px"
                                                    placeholder="123-123-123"
                                                    onChange={handleInputChange}
                                                    name="email"
                                                    value={item.email || ""}
                                                />
                                                <label className="d-flex align-items-center fs-13px">EMAIL</label>
                                            </form>

                                            <form onSubmit={(e) => e.preventDefault()} className="form-floating mb-3 ">
                                                <input
                                                    type="password"
                                                    className="form-control fs-15px"
                                                    placeholder="123-123-123"
                                                    onChange={handleInputChange}
                                                    name="password"
                                                    autoComplete="new-password"
                                                    value={item.password || ""}
                                                />
                                                <label className="d-flex align-items-center fs-13px">CONTRASENA</label>
                                            </form>

                                            {myuser?.admin && (
                                                <div className="row">
                                                    <label className="form-label col-form-label col-md-3">Administrador: </label>
                                                    <div className="col-md-4">
                                                        <div className="form-check mt-2 mb-2">
                                                            <input
                                                                disabled={!!!myuser?.admin}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                onChange={handleCheckboxChange}
                                                                name="admin"
                                                                checked={item.admin || false}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {myuser?.admin && (
                                                <div className="row">
                                                    <label className="form-label col-form-label col-md-3">Deshabilitado: </label>
                                                    <div className="col-md-4">
                                                        <div className="form-check mt-2 mb-2">
                                                            <input
                                                                disabled={!!!myuser?.admin}
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                onChange={handleCheckboxChange}
                                                                name="disabled"
                                                                checked={item.disabled || false}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-md-4"></div>
                                </div>
                            </PanelBody>
                        </EditItemView>
                    </Panel>
                </div>

                {myuser?.admin && (
                    <div className="col-lg-4">
                        <Panel>
                            <PanelHeader>CONEXIONES</PanelHeader>
                            <PanelBody>
                                <div className="row">
                                    <LinkSelect
                                        endpointAll="/api/tercero?all=true"
                                        endpointLinked={`/api/tercero?userId=${item.id}`}
                                        baseId={item.id}
                                        keyBase="userId"
                                        keyLink="terceroId"
                                        label="TERCEROS"
                                        titleGetter={(item) => item.razonsocial}
                                    />
                                </div>
                            </PanelBody>
                        </Panel>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DatosUsuario;
